// src/serviceWorkerRegistration.js

// This file safely unregisters service workers.
export function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
      });
    }
  }
  